import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import classes from '../styles.module.scss'
import { createCn } from '../../../helpers/utils'
import { Calendar, VideoIcon } from '../../../assets';
import TaskModal from './task-modal.component';
import { Draggable } from "@hello-pangea/dnd";
import { TaskItem } from '../../../services/api.service';

interface IProps {
  task: TaskItem;
  colTitle: string;
  index: number;
}

const cn = createCn("tasks", classes);

export function formatDueDate(dueDate?: string | null): string {
  if (!dueDate) return '';
  const date = new Date(dueDate);
  if (Number.isNaN(date.getTime())) return '';
  const pad = (n: number) => n.toString().padStart(2, '0');
  return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}`;
}

export function isOverdue(task: TaskItem): boolean {
  if (!task.due_date || task.status === 'done') return false;
  const due = new Date(task.due_date);
  if (Number.isNaN(due.getTime())) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return due < today;
}

const Task: React.FC<IProps> = ({ task, colTitle, index }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const dueLabel = formatDueDate(task.due_date);

  return (
    <Draggable draggableId={String(task.id)} index={index}>
      {(provided) => (
        <div
          className={cn("task")}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          <div className={cn("task__title")} onClick={() => setOpen(!open)}>{task.title}</div>
          <div className={cn("task__info")}>
            <div className={cn("task__info-item", { overdue: isOverdue(task) })}>
              <Calendar />
              {dueLabel || t('tasks-board.no-due-date')}
            </div>
            <div className={cn("task__priority", { [task.priority]: true })}>
              {t(`tasks-board.priority-${task.priority}`)}
            </div>
            {task.meeting_id && (
              <button
                type="button"
                className={cn("task__meeting-link")}
                title={t('tasks-board.open-meeting') || ''}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/files/${task.meeting_id}`);
                }}
              >
                <VideoIcon />
              </button>
            )}
          </div>
          <TaskModal
            open={open}
            setOpen={setOpen}
            task={task}
            colTitle={colTitle}
          />
        </div>
      )}
    </Draggable>
  )
}

export default Task
